import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getVatSettlemenDetails } from "../../../store/actions/reports/vatSettlement";
import {getDraftIdFromOriginalEntry} from "../../../store/actions/precog";
import DetailSummary from "./detailSummary";
import TableComplex from "../../vapor/tableComplex";
import "./style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import numeral from "numeral";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { DATE_FORMAT_FOR_DISPLAY } from "../../../constants/constants";
import { FormattedMessage, useIntl } from "react-intl";
import { isNumeric } from "../../../libs/utils";

const AliquoteDetailPage = () => {
  const settlementDetail = useSelector(state => state.reports.vat.detail);
  const aliquoteDetail = useSelector(state => state.reports.vat.aliquoteDetail);
  const [activityTotals, setActivityTotals] = useState([]);
  const [currentSettlement, setCurrentSettlement] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const intl = useIntl();

  let columnsSettlement = [
    {
      title: intl.formatMessage({id: "reports.vat.aliquoteDetail.reason"}),
      width: "14%",
      dataIndex: "reason",
      key: "reason"
    },
    {
      title: intl.formatMessage({id: "reports.vat.aliquoteDetail.registrationDate"}),
      width: "10%",
      dataIndex: "registrationDate",
      key: "registrationDate"
    },
    {
      title: intl.formatMessage({id: "reports.vat.aliquoteDetail.docNumber"}),
      width: "10%",
      dataIndex: "docNumber",
      key: "docNumber"
    },
    {
      title: intl.formatMessage({id: "reports.vat.aliquoteDetail.docDate"}),
      width: "10%",
      dataIndex: "docDate",
      key: "docDate"
    },
    {
      title: intl.formatMessage({id: "reports.vat.aliquoteDetail.vatCollectability"}),
      width: "10%",
      dataIndex: "vatCollectability",
      key: "vatCollectability"
    },
    {
      title: intl.formatMessage({id: "reports.vat.activityDetail.taxable"}),
      width: "10%",
      dataIndex: "taxable",
      key: "taxable"
    },
    {
      title: intl.formatMessage({id: "reports.vat.activityDetail.tax"}),
      width: "10%",
      dataIndex: "tax",
      key: "tax"
    },
    {
      title: "",
      width: "2%",
      dataIndex: "detail",
      key: "detail"
    }
  ];

  const goToDetails = (aliquote) => {
    dispatch(getDraftIdFromOriginalEntry(aliquote.registrationUuid)).then((res) => {
      navigate(`/precog-detail/${res}`, {state: {goBack: true}});      
    }).catch(err => {

    });
  };

  useEffect(() => {
    if (!location && !location.state) return;        
    dispatch(getVatSettlemenDetails(
      location?.state?.businessId, location?.state?.year, (isNumeric(location?.state?.month) ? moment(location?.state?.month, "M").locale("en").format("MMMM").toUpperCase() : location?.state?.month), location?.state?.type, location?.state?.journalType
    ));
  }, [location]);

  useEffect(() => {
    if (!settlementDetail) return;
    setCurrentSettlement(settlementDetail[0]);
  }, [settlementDetail]);

  useEffect(() => {
    if (!currentSettlement?.details) return;
    let totals = [];
    currentSettlement.details.forEach(el => {
      let taxableTotal = 0;
      let taxTotal = 0;
      el?.aliquotes?.map(el => { taxableTotal = taxableTotal + el.taxable; taxTotal = taxTotal + el.tax; });
      totals.push({ description: el.description.toLowerCase(), taxableTotal: taxableTotal, taxTotal: taxTotal, total: taxableTotal+taxTotal });
    });
    setActivityTotals(totals);
  }, [currentSettlement]);

  const buildDataSource = () => {
    return aliquoteDetail?.map((aliquote, key) => renderTableRow(aliquote, key));
  };

  const renderTableRow = (aliquote, key) => {
    return {
      key: key,
      aliquote: aliquote,
      reason: <div>{aliquote?.reasonDescription}</div>,
      registrationDate: <div>{moment(aliquote?.registrationDate).format(DATE_FORMAT_FOR_DISPLAY)}</div>,
      docNumber: <div>{aliquote?.docNumber}</div>,
      docDate: <div>{moment(aliquote?.docDate).format(DATE_FORMAT_FOR_DISPLAY)}</div>,
      vatCollectability: <div>{<FormattedMessage id={`reports.vat.aliquoteDetail.${aliquote?.vatLines[0].vatCollectability?.toUpperCase()}`} />}</div>,
      taxable: <div>{`${numeral(Math.abs(aliquote?.vatLines[0].taxable)).format("0,0.00")} €`}</div>,
      tax: <div>{`${numeral(Math.abs(aliquote?.vatLines[0].tax)).format("0,0.00")} €`}</div>,
      detail: <div style={{ fontSize: 16, color: "#0090d1", cursor: "pointer" }} 
        onClick={() => goToDetails(aliquote)}>
        <FontAwesomeIcon icon={["far", "arrow-right"]} />
      </div>
    };
  };  
  
  return (
    <div className="vatHeader">
      <DetailSummary activityTotals={activityTotals} currentSettlement={location?.state?.settlement?.businessSettlements?.[0] ? location?.state?.settlement?.businessSettlements?.[0] : currentSettlement} monthNumber={location?.state?.month}/>
      <TableComplex
        columns={columnsSettlement}
        dataSource={buildDataSource()}
      />  
    </div>
  );
};
export default AliquoteDetailPage;
